/**
 * @generated SignedSource<<1608b384c1e02cfecc31c0647fecd024>>
 * @relayHash 0c1030eef55050f3d6525b145dc1a4a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 925452c86ba4c457e1ac1efc99e6362fea14d65b359b9777c9449cbb78063a57

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SessionsPageQuery } from './SessionsPageQuery.graphql';

const node: PreloadableConcreteRequest<SessionsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "925452c86ba4c457e1ac1efc99e6362fea14d65b359b9777c9449cbb78063a57",
    "metadata": {},
    "name": "SessionsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
